import { render, staticRenderFns } from "./message-sending.vue?vue&type=template&id=906f1e26&scoped=true"
import script from "./message-sending.vue?vue&type=script&lang=js"
export * from "./message-sending.vue?vue&type=script&lang=js"
import style0 from "./message-sending.vue?vue&type=style&index=0&id=906f1e26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906f1e26",
  null
  
)

export default component.exports